module.exports = __webpack_public_path__ + "static/maker-manager-27302625ee8bd0c8b114ae94bda9a7b5.png";